export default "__VITE_ASSET__D9d$ld1B__"